import * as React from 'react'
import { 
  useDispatch,
  useSelector
 } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { 
  styled, 
  useTheme 
} from '@mui/material/styles'
import {
  AppBar,
  Stack,
  Button,
  Grid,
  Box,
  Toolbar,
  Typography,
  Container,
  Link
 } from '@mui/material'
import { 
  selectPage,
  loadPagesData
} from '../../redux/features/pages/pagesSlice'
import {
  setAllStikisOnPageUnselectedAsync,
  loadStikisData,
} from '../../redux/features/stikis/stikisSlice'
import { 
  welcomeStaticData 
} from '../../redux/features/pages/welcomeStaticData'

import StaticTopMenu from './StaticTopMenu'
import StikisField from '../../redux/features/stikis/StikisField'
import StaticFooter from './StaticFooter'

const classes = {
  callToAction: {
    bgcolor: (theme) => theme.palette.grey[200],
    pt: 5,
    pb: 5,
  }
}

function StaticWelcome(props) {
  const welcome_page = useSelector(selectPage(-1));  
  const dispatch = useDispatch()
  const navigate = useNavigate()

  React.useEffect(() => {
    if (!welcome_page) {
      dispatch(loadPagesData(welcomeStaticData))
      dispatch(loadStikisData(welcomeStaticData))
    }
  }, [dispatch, welcome_page])

  const handleClick = (e) => {
    if (!welcome_page) {
      return
    }
    console.log('Welcome.handleClick()')
    dispatch(setAllStikisOnPageUnselectedAsync(welcome_page.id))
  }

  const handleNavClick = (e) => {
    let path = e.currentTarget.href.replace(/https?\:\/\//, '')
      .replace(e.currentTarget.host, '')
    navigate(path)
    e.preventDefault()
    e.stopPropagation()
  }

  return (
    <React.Fragment>
      <StaticTopMenu />
      <main
        onClick={handleClick}
      >
        { /* Hero unit */ }
        <Box
          sx={{
            pt: 5,
          }}
        >
          <Container 
            sx={{}}
            maxWidth='md' 
          >
            <Typography 
              component='h2'
              variant='h2'
              sx = {{
                fontWeight: 'bold',
                color: "#202020",
              }}
              align='center'
              color='text.primary'
              gutterBottom
            >
              welcome to stikis
            </Typography>
          </Container>
          <Container maxWidth='md' sx={{
            minHeight: '300px',
            position: 'relative',
            pt: 5,
            pb: 5,
          }}>
            { Boolean(welcome_page) 
              ? (
                <StikisField 
                  pageId={-1} 
                  relativeLayout={true} 
                  disableZoom={true}
                  disableMove={true}
                  width={"100%"} 
                  height={"250px"} 
                  isStatic={true}
                />) 
              : (<Box></Box>)
            }
          </Container>
        </Box>
        <Box
          sx={{
            bgcolor: (theme) => theme.palette.grey[200],
            borderTop: '1px solid silver',
          }}
        >
          <Container 
            sx={classes.callToAction}
            maxWidth='md'
          >
            <Typography
              component='h4'
              variant='h4'
              align='center'
              color='text.primary'
              gutterBottom
            >
              Get started
            </Typography>
            <Stack
              sx={{ 
                pt: 2, 
                pb: 5,
                justifyContent: 'center'
              }}
              direction='row'
              spacing={2}
            >
              <Button
                variant='contained'
                onClick={handleNavClick}
                href='/app/sign_up'
                size='large'
                sx={{
                  padding: '16px 44px',
                  fontSize: '1.05rem',
                }}
              >Sign up</Button>
            </Stack>
            <Typography
              variant='body2'
              align='center'
            >
              Already have an account?&nbsp;
              <Link
                onClick={handleNavClick}
                href='/app/sign_in'
              >
                Sign in here
              </Link>
            </Typography>
          </Container>
        </Box>
      </main>
      <StaticFooter />
    </React.Fragment>
  )
}

export default StaticWelcome
